import { Component, OnInit, ViewChild, AfterViewInit, Output, EventEmitter, Input, ElementRef } from '@angular/core';
import { OrderEntry_NewModel } from './OrderEntry_New.model';
import { ComboBoxComponent } from '../../../combo-box/combo-box.component';
import { TextBoxComponent } from '../../../text-box/text-box.component';
import { ButtonComponent } from '../../../button/button.component';
import { FormComponent } from '../../../form/form.component';
import { ServiceStock } from '../../../service-stock.service';
import { HttpResponse } from '@angular/common/http';
import { ExchangeComponent } from '../../components/Exchange/Exchange.component';
import { ProductComponent } from '../../components/Product/Product.component';
import { InvestoridComponent } from '../../components/Investorid/Investorid.component';
import { StockComponent } from '../../components/Stock/Stock.component';
import { PriceComponent } from '../../components/Price/Price.component';
import { BoardComponent } from '../../components/Board/Board.component';
import { OrderValueComponent } from '../../components/OrderValue/OrderValue.component';
import { FillTypeComponent } from '../../components/FillType/FillType.component';
import { ValdtityDateComponent } from '../../components/ValdtityDate/ValdtityDate.component';
import { RepinQtyComponent } from '../../components/RepinQty/RepinQty.component';
import { gotxModalComponent } from 'src/app/gotxModal/gotxModal.component';
import { GotxMarketDepthComponent } from '../../components/gotx-market-depth/gotx-market-depth.component';
import { GotxChartComponent } from '../../components/gotx-chart/gotx-chart.component';
import { MarketWatchService } from 'src/app/market-watch.service';

const customCss: string = '';

@Component({
  selector: 'app-OrderEntry_New',
  templateUrl: './OrderEntry_New.component.html'
})
export class OrderEntry_NewComponent extends FormComponent implements OnInit, AfterViewInit {
  @ViewChild('orderEntryForm', { static: false }) orderEntryForm: ElementRef;
  @ViewChild('cstmExchange', { static: false }) cstmExchange: ExchangeComponent;
  @ViewChild('cstmProduct', { static: false }) cstmProduct: ProductComponent;
  @ViewChild('cstmInvestorId', { static: false }) cstmInvestorId: InvestoridComponent;
  @ViewChild('cmbStock', { static: false }) cmbStock: StockComponent;
  @ViewChild('cmbAction', { static: false }) cmbAction: ComboBoxComponent;
  @ViewChild('spnQuantity', { static: false }) spnQuantity: TextBoxComponent;
  @ViewChild('cmbOrderType', { static: false }) cmbOrderType: ComboBoxComponent;
  @ViewChild('cstmPrice', { static: false }) cstmPrice: PriceComponent;
  @ViewChild('cstmBoard', { static: false }) cstmBoard: BoardComponent;
  @ViewChild('cstmOrderValue', { static: false }) cstmOrderValue: OrderValueComponent;
  @ViewChild('cstmFillType', { static: false }) cstmFillType: FillTypeComponent;
  @ViewChild('cstmValidityDate', { static: false }) cstmValidityDate: ValdtityDateComponent;
  @ViewChild('cstmRepinQty', { static: false }) cstmRepinQty: RepinQtyComponent;
  @ViewChild('spnMinFillQty', { static: false }) spnMinFillQty: TextBoxComponent;
  @ViewChild('spnTriggerPrice', { static: false }) spnTriggerPrice: TextBoxComponent;
  @ViewChild('btnBuy', { static: false }) btnBuy: ButtonComponent;
  @ViewChild('btnSell', { static: false }) btnSell: ButtonComponent;
  @ViewChild('btnModify', { static: false }) btnModify: ButtonComponent;
  @ViewChild('btnCancel', { static: false }) btnCancel: ButtonComponent;
  @ViewChild('btnClose', { static: false }) btnClose: ButtonComponent;
  @ViewChild('marketDetailsGrp', { static: false }) marketDetailsGrp: ElementRef;
  @ViewChild('marketDepthTable', { static: false }) marketDepthTable: GotxMarketDepthComponent;
  @ViewChild('gotxChartComp', { static: false }) gotxChartComp: GotxChartComponent;
  @Input('orderEntryType') orderEntryType: string;
  @Input('params') params: any;
  @ViewChild('displaySymbol1', { static: false }) displaySymbol1: TextBoxComponent;
  @ViewChild('displaySymbol2', { static: false }) displaySymbol2: TextBoxComponent;
 // @Input('orderEntryType') orderEntryType: string;
  //@Input('params') params: any;
  skeletonContentLoaded = false;
  productSelectedforSearch = this.services.dataStore.getproductMasterData();
  Initialproduct = "";
  quantityValue = "";
  priceValue = "";
  productFromOption = "";
  productData : boolean = false;
  selectedStock:any;
  symbolflag : boolean = false;
  symbolData1 = "";
  symbolData2 = "";

  // @Output() selectedMenu = new EventEmitter<String>();
  @Output() buyorsellWindow: EventEmitter<any> = new EventEmitter<any>();

  async revalidate(): Promise<number> {
    var totalErrors = 0;
    super.beforeRevalidate();
    await Promise.all([
      this.cstmExchange.revalidate(),
      this.cstmProduct.revalidate(),
      this.cstmInvestorId.revalidate(),
      this.revalidateBasicField('cmbAction'),
      this.revalidateBasicField('spnQuantity'),
      this.revalidateBasicField('cmbOrderType'),
      this.cstmPrice.revalidate(),
      this.cstmBoard.revalidate(),
      this.cstmOrderValue.revalidate(),
      this.cstmFillType.revalidate(),
      this.cstmValidityDate.revalidate(),
      this.cstmRepinQty.revalidate(),
      this.revalidateBasicField('spnMinFillQty'),
      this.revalidateBasicField('spnTriggerPrice'),
      this.marketDetailsTabList_revalidate(),
    ]).then((errorCounts) => {
      errorCounts.forEach((errorCount) => {
        totalErrors += errorCount;
      });
    });
    this.errors = totalErrors;
    super.afterRevalidate();
    return totalErrors;
  }
  constructor(services: ServiceStock, private marketService: MarketWatchService) {
    super(services);
    this.value = new OrderEntry_NewModel();
    this.componentCode = 'OrderEntry_New';
    this.displayBorder = false;
    this.initHTabGroup('marketDetailsTabList', ['tabMarketDepth', 'tabIntradayChart',], 'tabMarketDepth', 1);
  }
  setReadOnly(readOnly) {
    super.setBasicFieldsReadOnly(readOnly);
    this.cstmExchange.setReadOnly(readOnly);
    this.cstmProduct.setReadOnly(readOnly);
    this.cstmInvestorId.setReadOnly(readOnly);
    this.cstmPrice.setReadOnly(readOnly);
    this.cstmBoard.setReadOnly(readOnly);
    this.cstmOrderValue.setReadOnly(readOnly);
    this.cstmFillType.setReadOnly(readOnly);
    this.cstmValidityDate.setReadOnly(readOnly);
    this.cstmRepinQty.setReadOnly(readOnly);
  }
  async onFormLoad() {
    this.setInputs(this.services.dataStore.getData(this.services.routing.currModal));
    this.openHTab('marketDetailsTabList', 'tabMarketDepth');
    let inputMap = new Map();         
    this.cstmProduct.setValue("ORDERENTRY");
    /*setTimeout(() => {
      console.log("this.cstmProduct.cmbProduct.dropDownOptions.Options[0]",this.cstmProduct.cmbProduct.dropDownOptions.Options[0]);
      console.log("this.cstmProduct.cmbProduct",this.cstmProduct.cmbProduct);

      this.cstmProduct.cmbProduct.setValue(this.cstmProduct.cmbProduct.dropDownOptions.Options[0]);
        }, 500);*/
    this.cstmProduct.cmbProduct.dropDownOptions.Options = this.services.dataStore.getcmbProductderivative();
    this.cstmProduct.cmbProduct.setValue(this.cstmProduct.cmbProduct.dropDownOptions.Options[0]);
   //this.cstmProduct.setValue(this.services.dataStore.getcmbProductderivative);
    this.spnQuantity.setValue((this.services.UserPreference.userPreference.orderentry.isqtyallowed && this.services.UserPreference.userPreference.orderentry.defaultqty) || 1); // **UserPreference
    this.cmbOrderType.setValue(this.services.UserPreference.userPreference.orderentry.priceType || "LIMIT"); // **UserPreference
    this.loadFillType(); // **UserPreference
    this.cstmValidityDate.dtValidityDate.setValue(this.services.dataStore.serverDateStringToDate(this.services.dataStore.getData("sysDate")));
    //console.log("fill type value",this.services.UserPreference.userPreference.orderentry.timeinforce);
    setTimeout(() => {
      //console.log("fill type value set",this.services.UserPreference.userPreference.orderentry.timeinforce);
      //console.log("Inside set timeout",this.params.orderEntryType);
      if (this.params.orderEntryType != "MODIFY" && this.params.orderEntryType != "CANCEL") {
        this.cstmFillType.cmbFillType.setValue(this.services.UserPreference.userPreference.orderentry.timeinforce || "GFD"); // **UserPreference
      }
    }, 250);
    //this.cstmFillType.cmbFillType.setValue(this.services.UserPreference.userPreference.orderentry.timeinforce || "GFD"); // **UserPreference
    this.cstmBoard.cmbBoard.setValue("NR");
    // this.cstmExchange.cmbExchange.setFocus(true);

    //this.cstmPrice.spnPrice.setFocus(true); //commented by shanmugapriya and focus added to qty
    this.spnQuantity.setFocus(true);
   
  this.reloadStock("NR"); 
    // this.params = {orderEntryType: "MODIFY"};
    // let orderEntryType = "";
    //added by pooja starts
    /*if (this.params.product == "COMDERV" && (this.params.orderEntryType == "MODIFY" || this.params.orderEntryType == "CANCEL")) {
      console.log("inside modify");
      //this.cmbStock_stockSelected(this.params.stock);
      let stockKey = this.params.exchange + "#" + this.params.product + "#NR#" + this.params.symbol;
      if (this.services.dataStore.stockMasterMap.has(stockKey)) {
         this.selectedStock = this.services.dataStore.stockMasterMap.get(stockKey);
         console.log("this.selectedStockkkkkkkkkkkk",this.selectedStock);
        }
    }*/
    //added by pooja ends

    if (this.params && this.params.orderEntryType) {
      //console.log("this.params order entry",this.params);
      this.orderAction(this.params.orderEntryType);

      this.cstmExchange.cmbExchange.setValue(this.params.exchange);
      this.cstmProduct.cmbProduct.setValue(this.params.product);
      if (this.params.board) {
        this.cstmBoard.cmbBoard.setValue(this.params.board);
        this.reloadStock(this.params.board);
      }
      this.cmbStock.gotxInput.val(this.params.symbol);

      if (this.params.orderEntryType == "MODIFY" || this.params.orderEntryType == "CANCEL") {
        this.cmbAction.setValue(this.params.buySell);
        this.cmbOrderType.setValue(this.params.orderType);
        // if (this.params.orderType != "LIMIT") {
        //this.loadFillType(); //this line commented by pooja as fill type from market watch and f2 not working
        // }
        //console.log("this.params.fillType",this.params.fillType);
        this.cstmFillType.cmbFillType.setValue(this.params.fillType);
        this.fieldChanges(this.params.orderEntryType);

        this.cstmValidityDate.dtValidityDate.setValue(this.params.expiryDateStr);
        this.cstmRepinQty.spnRepinQty.setValue(this.params.repinQty);
       setTimeout(() => {
        this.cstmRepinQty.spnRepinQty.setValue(0);
           }, 500);
       
        this.spnTriggerPrice.setValue(this.params.triggerPrice);

        if (this.params.minFillQty != null && this.params.minFillQty > 0) {
          this.spnMinFillQty.setValue(this.params.minFillQty);
        } else {
          this.spnMinFillQty.setValue("");
        }

      } else {
        this.loadFillType(); 
        this.fieldChanges(this.params.orderEntryType);
      }

      if (this.params.price) {
        var tempPrice = parseFloat(this.params.price);
        let truncated = Math.floor(tempPrice * 100)/100;
        this.cstmPrice.spnPrice.setValue(truncated.toFixed(2));
      }
      //changed by shanmuga priya to get qty mentioned in user preferrence
      this.spnQuantity.setValue((this.services.UserPreference.userPreference.orderentry.isqtyallowed && this.services.UserPreference.userPreference.orderentry.defaultqty) || this.params.qty);
      //this.spnQuantity.setValue(this.params.qty);
      //this.Initialproduct = this.cstmProduct.cmbProduct.getFieldValue(); //commented by shanmugapriya
      if (typeof this.Initialproduct == 'object' ){
        this.Initialproduct = this.cstmProduct.cmbProduct.getFieldValue().text;
    } else {
        this.Initialproduct = this.cstmProduct.cmbProduct.getFieldValue();
    }
    

   // this.productForOrderValue();
    //added by pooja starts
    if (this.params.product == "COMDERV" && (this.params.orderEntryType == "MODIFY" || this.params.orderEntryType == "CANCEL")) {
      this.productData = false;
      //this.cmbStock_stockSelected(this.params.stock);
      let stockKey = this.params.exchange + "#" + this.params.product + "#NR#" + this.params.symbol;
      if (this.services.dataStore.stockMasterMap.has(stockKey)) {
         this.selectedStock = this.services.dataStore.stockMasterMap.get(stockKey);
         this.selectedStock = this.selectedStock.value;
         this.params.selectedStockValue = this.selectedStock;
        }
        this.calculateOrderValue(this.params.product);
    }else{
      this.calculateOrderValue(this.Initialproduct);
    }
    //added by pooja ends
     // this.calculateOrderValue(this.Initialproduct);

      this.exchange = this.cstmExchange.cmbExchange.getFieldValue();
      //this.product = this.cstmProduct.cmbProduct.getFieldValue(); //commented by shanmugapriya
      if (typeof this.product  == 'object' ){
        this.product  = this.cstmProduct.cmbProduct.getFieldValue().text;
    }else {
      this.product = this.cstmProduct.cmbProduct.getFieldValue();
    }
      this.symbol = this.params.symbol;
      
      if (this.params.exchSymbol) {
        this.exchSymbol = this.params.exchSymbol;
      }
    } else {
      this.orderAction(this.orderEntryType.toUpperCase());
      this.fieldChanges(this.orderEntryType.toUpperCase());
    }
   /* this.keyValueList = []; //commented by shanmuga priya orderentry total ask issue
    this.keyValueList.push({ key: "OrderEntry_New.CircuitBreakerHigh", value: 'circuitHigh', textAlign: "right", format: '1.2-2' });
    this.keyValueList.push({ key: "OrderEntry_New.CircuitBreakerLow", value: 'circuitLow', textAlign: "right", format: '1.2-2' });
    this.keyValueList.push({ key: "MarketDepthGrid.TotalBidQty", value: 'totalBuyQty', textAlign: "right", format: '' });
    this.keyValueList.push({ key: "MarketDepthGrid.TotalAskQty", value: 'totalSellQty', textAlign: "right", format: '' });
    console.log("this.keyValueList",this.keyValueList);*/
    this.buyingPowerSummary(this.exchSymbol);
    //console.log("calling getquote onformload");
    //this.getQuoteAndSubscribe(); //commented by shanmuga priya orderentry total ask issue
    this.setDependencies();
   // this.cstmProduct.setProductDropDown();

   if(this.Initialproduct == "EQUITY" || this.Initialproduct == "EQUITY MARKET"){
    this.productData = true;
  }else{
    this.productData = false;
    }//added by pooja to hide available qty 
  }
 /* productForOrderValue(){
  if (this.params.product == "COMDERV" && (this.params.orderEntryType == "MODIFY" || this.params.orderEntryType == "CANCEL")) {
    console.log("inside modify");
    //this.cmbStock_stockSelected(this.params.stock);
    let stockKey = this.params.exchange + "#" + this.params.product + "#NR#" + this.params.symbol;
    console.log("stockKeykkkkkkkkkkkkkkkkkk",stockKey);
    console.log("this.services.dataStore.stockMasterMapwwwww",this.services.dataStore.stockMasterMap);
    if (this.services.dataStore.stockMasterMap.has(stockKey)) {
       this.selectedStock = this.services.dataStore.stockMasterMap.get(stockKey);
       this.selectedStock = this.selectedStock.value;
       console.log("this.selectedStockkkkkkkkkkkk",this.selectedStock);
      }
      this.calculateOrderValue(this.params.product);
  }else{
    this.calculateOrderValue(this.Initialproduct);
  }
}*/
  openChartTab() {
    this.openHTab('marketDetailsTabList', 'tabIntradayChart', true);
    this.exchange = this.cstmExchange.cmbExchange.getFieldValue();
    this.product = this.cstmProduct.cmbProduct.getFieldValue();
    if (typeof this.product == 'object' ){
      this.product = this.cstmProduct.cmbProduct.getFieldValue().text;
  }
    this.symbol = this.getSymbol();
    this.gotxChartComp.ngOnChanges();
  }
  setInputs(param: any) {
    let params = this.services.http.mapToJson(param);
    if (params['mode']) {
      this.mode = params['mode'];
    }
  }
  async submitForm(path, apiCode, serviceCode) {
    this.submitData['formName'] = 'OrderEntry_New';
    await super.submit(path, apiCode, serviceCode);
  }
  getFieldInfo() {
    this.amountComponent.forEach(field => { this.additionalInfo[field.fieldID + '_desc'] = field.getFieldInfo(); });
    this.comboFields.forEach(field => { this.additionalInfo[field.fieldID + '_desc'] = field.getFieldInfo(); });
    // this.fileUploadFields.forEach(field => { this.additionalInfo[field.fieldID + '_desc'] = field.getFieldInfo(); });
    this.additionalInfo['cstmExchange_desc'] = this.cstmExchange.getFieldInfo();
    this.additionalInfo['cstmProduct_desc'] = this.cstmProduct.getFieldInfo();
    this.additionalInfo['cstmInvestorId_desc'] = this.cstmInvestorId.getFieldInfo();
    this.additionalInfo['cstmPrice_desc'] = this.cstmPrice.getFieldInfo();
    this.additionalInfo['cstmBoard_desc'] = this.cstmBoard.getFieldInfo();
    this.additionalInfo['cstmOrderValue_desc'] = this.cstmOrderValue.getFieldInfo();
    this.additionalInfo['cstmFillType_desc'] = this.cstmFillType.getFieldInfo();
    this.additionalInfo['cstmValidityDate_desc'] = this.cstmValidityDate.getFieldInfo();
    this.additionalInfo['cstmRepinQty_desc'] = this.cstmRepinQty.getFieldInfo();
    return this.additionalInfo;
  }
  getFieldValue() {
    this.value.cstmExchange = this.cstmExchange.getFieldValue();
    this.value.cstmProduct = this.cstmProduct.getFieldValue();
    this.value.cstmInvestorId = this.cstmInvestorId.getFieldValue();
    this.value.cstmPrice = this.cstmPrice.getFieldValue();
    this.value.cstmBoard = this.cstmBoard.getFieldValue();
    this.value.cstmOrderValue = this.cstmOrderValue.getFieldValue();
    this.value.cstmFillType = this.cstmFillType.getFieldValue();
    this.value.cstmValidityDate = this.cstmValidityDate.getFieldValue();
    this.value.cstmRepinQty = this.cstmRepinQty.getFieldValue();
    return this.value;
  }
  setValue(inputValue, inputDesc = undefined) {
    this.setBasicFieldsValue(inputValue, inputDesc);
    this.cstmExchange.setValue(inputValue['cstmExchange'], inputDesc['cstmExchange_desc']);
    this.cstmProduct.setValue(inputValue['cstmProduct'], inputDesc['cstmProduct_desc']);
    this.cstmInvestorId.setValue(inputValue['cstmInvestorId'], inputDesc['cstmInvestorId_desc']);
    this.cstmPrice.setValue(inputValue['cstmPrice'], inputDesc['cstmPrice_desc']);
    this.cstmBoard.setValue(inputValue['cstmBoard'], inputDesc['cstmBoard_desc']);
    this.cstmOrderValue.setValue(inputValue['cstmOrderValue'], inputDesc['cstmOrderValue_desc']);
    this.cstmFillType.setValue(inputValue['cstmFillType'], inputDesc['cstmFillType_desc']);
    this.cstmValidityDate.setValue(inputValue['cstmValidityDate'], inputDesc['cstmValidityDate_desc']);
    this.cstmRepinQty.setValue(inputValue['cstmRepinQty'], inputDesc['cstmRepinQty_desc']);
    this.value = new OrderEntry_NewModel();
    this.value.setValue(inputValue);
    this.setDependencies();
    this.passNewValue(this.value);
  }
  setProductField(value: string): void {
   // this.productFromOption = value;
    if(value == "EQUITY"){
        this.productSelectedforSearch = value;
    }else if(value == "FUTCOM" || value == "OPTCOM" || value == "COMDERV" ){
        this.productSelectedforSearch = "COMDERV";
    }else if(value == "FUTSTK" || value == "FUTIDX" || value == "OPTSTK" || value == "OPTIDX" || value == "FUTOPT"){
        this.productSelectedforSearch = "FUTOPT";
    }
   
    
  }

  
  ngOnInit() {
    if (this.formCode == undefined) { this.formCode = 'OrderEntry_New'; }
    if (this.formOnLoadError) { return; }
    setTimeout(() => {
      this.skeletonContentLoaded = true;
    }, 1000);
    var styleElement = document.createElement('style');
    styleElement.type = 'text/css';
    styleElement.innerHTML = customCss;
    styleElement.id = 'OrderEntry_New_customCss';
    document.getElementsByTagName('head')[0].appendChild(styleElement);

    setTimeout(() => {
      if (this.orderEntryType.toUpperCase() == "BUY") {
        this.orderEntryForm.nativeElement.style.backgroundColor = 'var(--buy-color-entry)';
      } else if (this.orderEntryType.toUpperCase() == "SELL") {
        this.orderEntryForm.nativeElement.style.backgroundColor = 'var(--sell-color-entry)';
      }

      // this.spnQuantity.setValue(1);
      // this.cmbOrderType.setValue("LIMIT");
      // this.cstmValidityDate.dtValidityDate.setValue(this.services.dataStore.serverDateStringToDate(this.services.dataStore.getData("sysDate")));
      // this.cstmFillType.cmbFillType.setValue("GFD");
    });
    this.setProductField(this.productSelectedforSearch);
  }
  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
    var styleElement = document.getElementById('OrderEntry_New_customCss');
    styleElement.parentNode.removeChild(styleElement);
    if (this.subbedStock != null)
      this.marketService.unSubscribeMarket([this.subbedStock]); // unsubscribe
  }
  ngAfterViewInit() {
    setTimeout(() => {
      this.subsBFldsValueUpdates();
      this.value.cstmExchange = this.cstmExchange.getFieldValue();
      this.cstmExchange.valueChangeUpdates().subscribe((value) => { this.value.cstmExchange = value; });
      this.value.cstmProduct = this.cstmProduct.getFieldValue();
      this.cstmProduct.valueChangeUpdates().subscribe((value) => { this.value.cstmProduct = value; });
      this.value.cstmInvestorId = this.cstmInvestorId.getFieldValue();
      this.cstmInvestorId.valueChangeUpdates().subscribe((value) => { this.value.cstmInvestorId = value; });
      this.value.cstmPrice = this.cstmPrice.getFieldValue();
      this.cstmPrice.valueChangeUpdates().subscribe((value) => { this.value.cstmPrice = value; });
      this.value.cstmBoard = this.cstmBoard.getFieldValue();
      this.cstmBoard.valueChangeUpdates().subscribe((value) => { this.value.cstmBoard = value; });
      this.value.cstmOrderValue = this.cstmOrderValue.getFieldValue();
      this.cstmOrderValue.valueChangeUpdates().subscribe((value) => { this.value.cstmOrderValue = value; });
      this.value.cstmFillType = this.cstmFillType.getFieldValue();
      this.cstmFillType.valueChangeUpdates().subscribe((value) => { this.value.cstmFillType = value; });
      this.value.cstmValidityDate = this.cstmValidityDate.getFieldValue();
      this.cstmValidityDate.valueChangeUpdates().subscribe((value) => { this.value.cstmValidityDate = value; });
      this.value.cstmRepinQty = this.cstmRepinQty.getFieldValue();
      this.cstmRepinQty.valueChangeUpdates().subscribe((value) => { this.value.cstmRepinQty = value; });

      this.onFormLoad();
      this.checkForHTabOverFlow();
    });
  }
  clearError() {
    super.clearBasicFieldsError();
    super.clearHTabErrors();
    super.clearVTabErrors();
    this.cstmExchange.clearError();
    this.cstmProduct.clearError();
    this.cstmInvestorId.clearError();
    this.cstmPrice.clearError();
    this.cstmBoard.clearError();
    this.cstmOrderValue.clearError();
    this.cstmFillType.clearError();
    this.cstmValidityDate.clearError();
    this.cstmRepinQty.clearError();
    this.errors = 0;
    this.errorMessage = [];
  }
  onReset() {
    super.resetBasicFields();
    this.cstmExchange.onReset();
    this.cstmProduct.onReset();
    this.cstmInvestorId.onReset();
    this.cstmPrice.onReset();
    this.cstmBoard.onReset();
    this.cstmOrderValue.onReset();
    this.cstmFillType.onReset();
    this.cstmValidityDate.onReset();
    this.cstmRepinQty.onReset();
    this.clearHTabErrors();
    this.clearVTabErrors();
    this.errors = 0;
    this.errorMessage = [];
    this.additionalInfo = undefined;
    this.dependencyMap.clear();
    this.value = new OrderEntry_NewModel();
    this.passNewValue(this.value);
    this.setReadOnly(false);
    this.onFormLoad();
  }
  async cstmExchange_exchSelected(event) {
    let inputMap = new Map();
    this.cstmProduct.updateProductList(this.cstmExchange.cmbExchange.getFieldValue());
    this.reloadStock(this.cstmBoard.cmbBoard.getFieldValue());
  }
  async cstmProduct_productSelected(event) {
    let inputMap = new Map();
    this.reloadStock(this.cstmBoard.cmbBoard.getFieldValue());
    this.buyingPowerSummary(this.exchSymbol);
    //this.productFromOption = event;
    //console.log("this.productFromOption",this.productFromOption);
  }
  async cmbStock_stockSelected(event) {
    let inputMap = new Map();
    this.exchange = this.cstmExchange.cmbExchange.getFieldValue();
    this.product = this.cstmProduct.cmbProduct.getFieldValue();
    if (typeof this.product == 'object' ){
      this.product = this.cstmProduct.cmbProduct.getFieldValue().text;
  }
   
    this.symbol = this.getSymbol();
    if(event == null || event == ""){
      this.quantityValue = "";
      this.priceValue = "";
    }
    if (this.cmbStock.gotxInput.val().value != this.cmbStock.gotxInput.val().label) {
      this.exchSymbol = this.cmbStock.gotxInput.val().value;
    //  console.log("this.exchSymbol 11",this.exchSymbol);
      //added by pooja 
      this.product = this.services.dataStore.getProductForMarketWatch(this.product);
      let key = this.exchange + "#" + this.product + "#NR#" + this.exchSymbol;
      if (this.services.dataStore.stockMasterMap.has(key)) {
          this.selectedStock = this.services.dataStore.stockMasterMap.get(key);
         this.quantityValue = "("+this.selectedStock.qtyUnit +")";
         this.priceValue = "("+this.selectedStock.priceUnit +")";
      }
     
      //added by pooja 
    } else {
      this.product = this.services.dataStore.getProductForMarketWatch(this.product);
      let stockKey = this.exchange + "#" + this.product + "#NR#" + this.symbol;
      if (this.services.dataStore.stockMasterMap.has(stockKey)) {
         this.selectedStock = this.services.dataStore.stockMasterMap.get(stockKey);
        this.exchSymbol = this.selectedStock.exchSymbol;
        this.quantityValue = "("+this.selectedStock.qtyUnit +")";
        this.priceValue = "("+this.selectedStock.priceUnit +")";
       
      }
    }
    //added by pooja starts
    
    if(this.symbol.endsWith("SPD") || this.symbol.endsWith("spd")){
      this.symbolflag = true;
      let stockKey = this.exchange + "#" + this.product + "#NR#" + this.selectedStock.symbol1;
      //console.log("stockKey1 order entry",stockKey);
      //console.log("stockKey1 this.selectedStock.symbol1",this.selectedStock.symbol1);
      if (this.services.dataStore.stockMasterMap.has(stockKey)) {
        let symbollist1  = this.services.dataStore.stockMasterMap.get(stockKey);
        //console.log("symbollist1",symbollist1);
        this.symbolData1 = symbollist1.symbol;
        //console.log("this.symbolData2",this.symbolData2);
        setTimeout(()=>{ 
          if(this.cmbAction.getFieldValue() == "BUY"){
            this.displaySymbol1.setValue(this.symbolData1);  // set as symboldata1 by shanmugapriya
          }else{
            this.displaySymbol1.setValue(this.symbolData2);  // set as symboldata2 by shanmugapriya
          }
        }, 1000);
        //this.displaySymbol1.setValue(this.symbolData1);
        //this.displaySymbol1.value = this.symbolData1
      }
      let stockKey2 = this.exchange + "#" + this.product + "#NR#" + this.selectedStock.symbol2;
      //console.log("stockKey2 order entry",stockKey2);
      //console.log("stockKey2 this.selectedStock.symbol2",this.selectedStock.symbol2);

      if (this.services.dataStore.stockMasterMap.has(stockKey2)) {
        let symbollist2 = this.services.dataStore.stockMasterMap.get(stockKey2);
        //console.log("symbollist2",symbollist2);
        this.symbolData2 = symbollist2.symbol;
        //console.log("this.symbolData1",this.symbolData1);
        setTimeout(()=>{ 
          if(this.cmbAction.getFieldValue() == "BUY"){
            this.displaySymbol2.setValue(this.symbolData2);  // set as symboldata2 by shanmugapriya
          }else{
            this.displaySymbol2.setValue(this.symbolData1);  // set as symboldata1 by shanmugapriya
          }
        }, 1000);
      }
    }else{
      this.symbolflag = false;
    }
    var fieldAction = this.cmbAction.getFieldValue();
    if(fieldAction == "BUY" || fieldAction == "Buy" || fieldAction == "SELL" || fieldAction == "Sell")
    if(this.product == "COMDERV" || this.product == "FUTOPT"){
      var symbolValue = this.cmbStock.gotxInput.val().value;
      //console.log("this.selectedStock.product",symbolValue);
      let key = this.exchange + "#" + this.product + "#NR#" + symbolValue;
      if (this.services.dataStore.stockMasterMap.has(key)) {
        var stockList = this.services.dataStore.stockMasterMap.get(key);
      
        setTimeout(()=>{ 
          if(!this.spnQuantity.value){ // added falsy check, 05jun2025:ssr
             this.spnQuantity.setValue(stockList.lotsize);
          }
        }, 1000);
      }
    }
    //added by pooja ends

    if (!this.exchSymbol || this.exchSymbol.length <= 0) {
      return;
    }

    this.buyingPowerSummary(this.exchSymbol);
    //console.log("calling getquote 1 cmbstock");
    this.getQuoteAndSubscribe();
    
    this.keyValueList = [];
    this.keyValueList.push({ key: "OrderEntry_New.CircuitBreakerHigh", value: 'circuitHigh', textAlign: "right", format: '1.2-2' });
    this.keyValueList.push({ key: "OrderEntry_New.CircuitBreakerLow", value: 'circuitLow', textAlign: "right", format: '1.2-2' });
    this.keyValueList.push({ key: "MarketDepthGrid.TotalBidQty", value: 'totalBuyQty', textAlign: "right", format: '' });
    this.keyValueList.push({ key: "MarketDepthGrid.TotalAskQty", value: 'totalSellQty', textAlign: "right", format: '' });
    //console.log("this.keyValueList cmbstock",this.keyValueList);
    // this.cstmBoard.cmbBoard.setValue(this.services.dataStore.getBoardByExchSymbol(this.exchSymbol));
  }
  async cmbAction_change(event) {
    let inputMap = new Map();
  
    if(this.symbol.endsWith("SPD") || this.symbol.endsWith("spd")){
      setTimeout(()=>{
        if(this.cmbAction.getFieldValue() == "BUY"){
          this.displaySymbol1.setValue(this.symbolData2);  // 17jul2025:ssr
        }else{
          this.displaySymbol1.setValue(this.symbolData1);  // 17jul2025:ssr
        }
        
        if(this.cmbAction.getFieldValue() == "SELL"){
          this.displaySymbol2.setValue(this.symbolData2);  // 17jul2025:ssr
        }else{
          this.displaySymbol2.setValue(this.symbolData1);  // 17jul2025:ssr
        }
      }, 250);
    }
  
    this.orderAction(this.cmbAction.getFieldValue());
    this.buyorsellWindow.emit(this.cmbAction.getFieldValue());
  }
  async spnQuantity_change(event) {
    let inputMap = new Map();
    this.Initialproduct = this.cstmProduct.cmbProduct.getFieldValue(); 
    if (typeof this.Initialproduct == 'object' ){
      this.Initialproduct = this.cstmProduct.cmbProduct.getFieldValue().text;
  }
      this.calculateOrderValue(this.Initialproduct);
    //this.calculateOrderValue();
  }
  async cmbOrderType_change(event) {
    let inputMap = new Map();
    this.loadFillType(); //this line commented by pooja as fill type from market watch and f2 not working
    this.fieldChanges(event);
  }
  async cstmPrice_priceChanged(event) {
    let inputMap = new Map();
    this.Initialproduct = this.cstmProduct.cmbProduct.getFieldValue(); 
    if (typeof this.Initialproduct == 'object' ){
      this.Initialproduct = this.cstmProduct.cmbProduct.getFieldValue().text;
  }
      this.calculateOrderValue(this.Initialproduct);
   // this.calculateOrderValue();
  }
  async cstmBoard_boardSelected(event) {
    let inputMap = new Map();
   this.loadFillType(); //this line commented by pooja as fill type from market watch and f2 not working
    this.fieldChanges(event);
  }
  async cstmFillType_fillTypeSelected(event) {
    let inputMap = new Map();
    this.fieldChanges(event, "fillTypeChange");
  }
  async cstmRepinQty_repinQtySelected(event) {
    let inputMap = new Map();
  }
  async loadFillType() {
    let fillType = this.services.dataStore.getFillType(this.cstmBoard.cmbBoard.getFieldValue(), this.cmbOrderType.getFieldValue(),this.product);

    this.cstmFillType.cmbFillType.dropDownOptions.Options = [{ id: undefined, text: this.cstmFillType.cmbFillType.placeholder }];
    this.cstmFillType.cmbFillType.dropDownOptions.Options = this.cstmFillType.cmbFillType.dropDownOptions.Options.concat(fillType);

    // this.cstmFillType.cmbFillType.dropDownOptions.Options = fillType;

    if (this.params.orderEntryType != "MODIFY" && this.params.orderEntryType != "CANCEL") {
      this.cstmFillType.cmbFillType.setValue(fillType[0].id);
    }
  }
  async btnBuy_click(event) {
    let inputMap = new Map();
    var errorCount: number = await this.revalidate();
    if (this.getSymbol() == undefined || this.getSymbol().toString() == '' || this.getSymbol().length == 0) {
      errorCount++;
      this.cmbStock.setError("Value cannot be empty");
    }
    document.getElementById('errMsgDiv2').innerHTML = "";
    if (errorCount == 0) {
      // this.services.http.oeLoggedIn = true;
      if (this.services.http.oeLoggedIn == false) {
        this.authenticateOrder("buyOrSell");
      } else {
        this.confirmOrder("buyOrSell");
      }
    }
  }
  async btnSell_click(event) {
    let inputMap = new Map();
    this.btnBuy_click(event);
  }
  async btnModify_click(event) {
    let inputMap = new Map();
    var errorCount: number = await this.revalidate();
    document.getElementById('errMsgDiv2').innerHTML = "";
    if (errorCount == 0) {
      // this.services.http.oeLoggedIn = true;
      if (this.services.http.oeLoggedIn == false) {
        this.authenticateOrder("MODIFY");
      } else {
        this.modifyOrder(event);
      }
    }

  }
  async btnCancel_click(event) {
    let inputMap = new Map();
    var errorCount: number = await this.revalidate();
    document.getElementById('errMsgDiv2').innerHTML = "";
    if (errorCount == 0) {
      // this.services.http.oeLoggedIn = true;
      if (this.services.http.oeLoggedIn == false) {
        this.authenticateOrder("CANCEL");
      } else {
        this.cancelOrder(event);
      }
    }
  }
  async btnClose_click(event) {
    let inputMap = new Map();
  }
  async tabMarketDepth_revalidate(): Promise<number> {
    var totalErrors = 0;
    await Promise.all([
    ]).then((errorCounts) => {
      errorCounts.forEach((errorCount) => {
        totalErrors += errorCount;
      });
    });
    this.hTabGroups['marketDetailsTabList'].tabs['tabMarketDepth'].errorCount = totalErrors;
    return totalErrors;
  }
  async tabIntradayChart_revalidate(): Promise<number> {
    var totalErrors = 0;
    await Promise.all([
    ]).then((errorCounts) => {
      errorCounts.forEach((errorCount) => {
        totalErrors += errorCount;
      });
    });
    this.hTabGroups['marketDetailsTabList'].tabs['tabIntradayChart'].errorCount = totalErrors;
    return totalErrors;
  }
  async marketDetailsTabList_revalidate(): Promise<number> {
    var totalErrors = 0;
    await Promise.all([
      this.tabMarketDepth_revalidate(),
      this.tabIntradayChart_revalidate(),
    ]).then((errorCounts) => {
      errorCounts.forEach((errorCount) => {
        totalErrors += errorCount;
      });
    });
    return totalErrors;
  }
  calculateOrderValue(InitialProduct) {
    if(this.selectedStock == undefined ||this.selectedStock == "undefined" ){
       var symbol = this.cmbStock.gotxInput.val().label;
      var exchange = this.cstmExchange.cmbExchange.getFieldValue();
      var product = this.cstmProduct.cmbProduct.getFieldValue();
    if (typeof product == 'object' ){
      product = this.cstmProduct.cmbProduct.getFieldValue().text;
  }
  product = this.services.dataStore.getProductForMarketWatch(product);
      let stockKey =  exchange + "#" + product + "#NR#" + symbol;
     //let stockKey = "CTG#COMDERV#NR#FUTCOM-GOLD-03Apr2015-XX";

      if (this.services.dataStore.stockMasterMap.has(stockKey)) {
         this.selectedStock = this.services.dataStore.stockMasterMap.get(stockKey); 
         //console.log("this.selectedStock after",this.selectedStock);
        }else{
          //console.log("In else loop");
        }
    }
    if(InitialProduct == "EQUITY" || InitialProduct == "EQUITY MARKET" || InitialProduct == "FUTSTK" || 
      InitialProduct == "FUTIDX" || InitialProduct == "OPTIDX" || InitialProduct == "OPTSTK" 
      || InitialProduct == "FUTOPT"){
    var total = this.cstmPrice.spnPrice.getFieldValue() * this.spnQuantity.getFieldValue();
    this.cstmOrderValue.txtOrderValue.setValue(total.toFixed(2));
  }else{
    var priceNumerator = this.selectedStock.priceNumerator;
    var priceDenominator = this.selectedStock.priceDenominator;
    var lotNumerator = this.selectedStock.lotNumerator;
    var lotDenominator = this.selectedStock.lotDenominator;
    var lotsize = this.selectedStock.lotsize;
   // var total = (this.cstmPrice.spnPrice.getFieldValue() * priceNumerator/priceDenominator )*this.spnQuantity.getFieldValue()* lotsize *(lotNumerator/lotDenominator);
  var total = (this.cstmPrice.spnPrice.getFieldValue() * priceNumerator/priceDenominator )*
  (this.spnQuantity.getFieldValue()*lotNumerator/lotDenominator);

    this.cstmOrderValue.txtOrderValue.setValue(total.toFixed(2));
  }

  }
  async authenticateOrder(orderEntryType: string) {
    let inputMap = new Map();
    const modalRef = this.services.modal.open(gotxModalComponent,
      {
        ariaLabelledBy: 'modal-basic-title',
        size: 'sm',
        scrollable: true,
        windowClass: 'myCustomModalClass',
        backdrop: 'static',
      });
    let params = {
      title: 'Authentication',
      message: 'Please reverify password',
    }
    modalRef.componentInstance.selectedMenu = "Authentication";
    modalRef.componentInstance.params = params;
    modalRef.result.then((res) => {
      if (res == "ok") {
        if (orderEntryType == "MODIFY") {
          this.modifyOrder(event);
        } else if (orderEntryType == "CANCEL") {
          this.cancelOrder(event);
        } else {
          this.confirmOrder(event);
        }
      }
    }, () => {
    });
  }
  async buyingPowerSummary(exchSymbol = "") {
    let inputMap = new Map();
    inputMap.set('Body.exchangeID', this.cstmExchange.cmbExchange.getFieldValue());
    inputMap.set('Body.symbol', exchSymbol);
    inputMap.set('Body.clientId', this.cstmInvestorId.cmbInvestorId.getFieldValue());
    var productValue = this.cstmProduct.cmbProduct.getFieldValue(); 
    if (typeof productValue == 'object' ){
      productValue= productValue.text;
  }
    if(productValue == "EQUITY" || productValue == "EQUITY MARKET"){
      inputMap.set('Body.marginGroupNo', 1);
    }else if( productValue == "FUTSTK" || productValue == "OPTSTK" || productValue == "FUTIDX" || productValue == "OPTIDX" || productValue == "FUTOPT"){
      inputMap.set('Body.marginGroupNo', 3);
    }else {
      inputMap.set('Body.marginGroupNo', 2);
    }
   

    this.services.http.fetchApi('/buyingpower', 'POST', inputMap).subscribe(
      async (httpResponse: HttpResponse<any>) => {
        var res = httpResponse.body;
        var respCode: any = res['respCode'];
        if (respCode != null && respCode == 0) {
          this.buyingSummary = res['response']['buyPower']['buyingPower'];
          this.availableQty = res['response']['buyPower']['avaQty'];
        }
      },
      async (httpError) => {
        var err = httpError['error']
        if (err != null && err['ErrorElementPath'] != undefined && err['ErrorDescription'] != undefined) {
          if (err['ErrorElementPath'] == 'clientId') {
            this.cstmInvestorId.cmbInvestorId.setError(err['ErrorDescription']);
          }
          else if (err['ErrorElementPath'] == 'exchangeID') {
            this.cstmExchange.cmbExchange.setError(err['ErrorDescription']);
          }
        }
      }
    );
  }
  async getQuoteAndSubscribe() {
	//console.log("Inside async getQuoteAndSubscribe");
    let board = this.cstmBoard.cmbBoard.getFieldValue();
    let stockKey = this.exchange + "#" + this.product + "#" + board + "#" + this.symbol;
    this.selectedStock = this.services.dataStore.stockMasterMap.get(stockKey);
    //console.log("getQuoteAndSubscribe -- selectedStock",this.selectedStock);
    if (!this.selectedStock) {
      return;
    }

    this.marketService.getStockQuote(this.exchange, this.product, this.symbol);

    if (this.selectedStock && this.exchSymbol && this.exchSymbol.length <= 0) {
      this.exchSymbol = this.selectedStock.exchSymbol;
    }

    let alreadySub = this.services.dataStore.subbedStocks.filter(el => el.Exch == this.exchange && el.Symbol == this.exchSymbol
      && el.Product == this.product);

    //console.log("alreadySub", alreadySub);

    if (this.subbedStock != null) {
      this.marketService.unSubscribeMarket([this.subbedStock]); // unsubscribe
    }

    if ((alreadySub == null || alreadySub.length <= 0) && this.exchSymbol != null) {
      this.subbedStock = { "Symbol": this.exchSymbol, "Exch": this.exchange, "Product": this.product };
      this.marketService.marketWatchStockSubs([this.subbedStock], 'DEPTH.IWS.DATA.REQ');//DEPTH.DATA.REQ // MW.IWS.STOCKS.SUBS
    } else {
      this.subbedStock = null;
    }

    if (!this.marketDepthTable.getSelectedStock()) {
      this.marketDepthTable.setSelectedStock(this.selectedStock);
    }
  }
  async orderAction(event: string) {
    let inputMap = new Map();
    this.btnModify.setHiddenButton(true);
    this.btnCancel.setHiddenButton(true);
    this.btnClose.setHiddenButton(true);
    this.btnBuy.setHiddenButton(true);
    this.btnSell.setHiddenButton(true);
    this.cmbAction.setValue(event);
    if (event === "BUY") {
      this.orderEntryForm.nativeElement.style.backgroundColor = 'var(--buy-color-entry)';
      this.btnBuy.setHiddenButton(false);
    }
    else if (event === "SELL") {
      this.orderEntryForm.nativeElement.style.backgroundColor = 'var(--sell-color-entry)';
      this.btnSell.setHiddenButton(false);

    } else if (event === "MODIFY") {
      this.btnModify.setHiddenButton(false);

    } else if (event === "CANCEL") {
      this.btnCancel.setHiddenButton(false);
    }
  }
  async fieldChanges(event: string, changeType: string = "other") {
    let inputMap = new Map();
    let orderType = this.cmbOrderType.getFieldValue();
    let fillType = this.cstmFillType.cmbFillType.getFieldValue();

    this.cstmBoard.cmbBoard.setReadOnly(true);
    // Validity Date Starts
    if (fillType == "GTD") {
      this.cstmValidityDate.dtValidityDate.setMandatory(true);
      this.cstmValidityDate.setReadOnly(false);
    } else {
      this.cstmValidityDate.dtValidityDate.setValue(this.services.dataStore.serverDateStringToDate(this.services.dataStore.getData("sysDate")));
      this.cstmValidityDate.dtValidityDate.setMandatory(false);
      this.cstmValidityDate.setReadOnly(true);
    }
    // Validity Date Ends
    // Min Fill Qty Starts

    // if (board == "NR" && (orderType == "MARKET" || orderType == "STOPMARKET")) {
    if (fillType == "MFL") {
      this.spnMinFillQty.setMandatory(true);
      this.spnMinFillQty.setReadOnly(false);
    } else {
      this.spnMinFillQty.setMandatory(false);
      this.spnMinFillQty.setReadOnly(true);
      this.spnMinFillQty.setValue("");
    }
    // Min Fill Qty Ends
    if (changeType == "other") {
      // Trigger Price Starts
      this.spnTriggerPrice.setValue("");
      this.spnTriggerPrice.setReadOnly(true);
      this.spnTriggerPrice.setMandatory(false);
      if (orderType == "STOPMARKET" || orderType == "STOPLIMIT") {
        this.spnTriggerPrice.setReadOnly(false);
        this.spnTriggerPrice.setMandatory(true);
      }
      // Trigger Price Ends
      // Price Starts
      this.cstmPrice.spnPrice.setValue("");
      this.cstmPrice.spnPrice.setReadOnly(true);
      this.cstmPrice.spnPrice.setMandatory(false);
      if (orderType == "LIMIT" || orderType == "STOPLIMIT") {
        this.cstmPrice.spnPrice.setReadOnly(false);
        this.cstmPrice.spnPrice.setMandatory(true);
        this.cstmPrice.spnPrice.setValue(0.00);
        this.cstmRepinQty.spnRepinQty.setValue(0);
      }
      // Price Ends
    }
    this.Initialproduct = this.cstmProduct.cmbProduct.getFieldValue();
    if (typeof this.Initialproduct == 'object' ){
      this.Initialproduct = this.cstmProduct.cmbProduct.getFieldValue().text;
  } 
  //console.log("this.calculateOrderValue 1"); //commented bt pooja
  //this.Initialproduct = this.params.product;
     // this.calculateOrderValue(this.Initialproduct);//commented bt pooja
    //this.calculateOrderValue();

    this.cstmRepinQty.spnRepinQty.setMandatory(false);
    this.cstmRepinQty.spnRepinQty.setValue(0);// added by kala
    // this.spnTriggerPrice.setValue(0);
    // this.spnMinFillQty.setValue(0);

    if (event == "MODIFY" || event == "CANCEL") {
      this.cstmExchange.setHidden(true);
      this.cstmProduct.setHidden(true);
      this.cstmInvestorId.setHidden(true);
      this.cmbAction.setHidden(true);
      this.cmbOrderType.setHidden(true);
      // this.spnMinFillQty.setHidden(true);
      // this.spnMinFillQty.setReadOnly(true);
      this.cmbStock.setReadOnly(true);
      this.cstmBoard.setReadOnly(true);
      // this.cstmFillType.setReadOnly(true);
    }

    if (event == "CANCEL") {
      // this.spnTriggerPrice.setHidden(true);
      this.spnQuantity.setReadOnly(true);
      this.cstmPrice.setReadOnly(true);
      this.cstmRepinQty.setReadOnly(true);
      this.cstmFillType.setReadOnly(true);
    }
  }
  getSymbol() {
    if (this.cmbStock.gotxInput.val().label) {
      return this.cmbStock.gotxInput.val().label;
    } else {
      return this.cmbStock.gotxInput.val();
    }
  }
  async confirmOrder(event) {
    let inputMap = new Map();
    let ProductValue =this.cstmProduct.cmbProduct.getFieldValue();
    if (typeof ProductValue == 'object' ){
      ProductValue = ProductValue.text;
  }
    inputMap.set('Body.boardType', this.cstmBoard.cmbBoard.getFieldValue());
    inputMap.set('Body.buysell', this.cmbAction.getFieldValue());
    inputMap.set('Body.clientid', this.cstmInvestorId.cmbInvestorId.getFieldValue());
    //inputMap.set('Body.disquan', "0");commented by kala
    inputMap.set('Body.disquan', parseInt(this.cstmRepinQty.spnRepinQty.getFieldValue()));
    inputMap.set('Body.exchange', this.cstmExchange.cmbExchange.getFieldValue());
    //inputMap.set('Body.expirydate',"2022-09-14");
    inputMap.set('Body.expirydate', this.services.dataStore.dateToDateString(this.cstmValidityDate.dtValidityDate.getFieldValue()));
    inputMap.set('Body.filltype', this.cstmFillType.cmbFillType.getFieldValue());
    inputMap.set('Body.minFillQty', parseInt(this.spnMinFillQty.getFieldValue()));
    inputMap.set('Body.price', parseFloat(this.cstmPrice.spnPrice.getFieldValue()));
    inputMap.set('Body.pricetype', this.cmbOrderType.getFieldValue());
    var productFromUI = this.cstmProduct.cmbProduct.getFieldValue();
    if (typeof productFromUI == 'object' ){
      productFromUI = productFromUI.text
  }
    if(productFromUI == "FUTCOM" || productFromUI == "OPTCOM"){
      inputMap.set('Body.product', "COMDERV");
    }else if(productFromUI == "FUTSTK" || productFromUI == "FUTIDX" || productFromUI == "OPTSTK" || productFromUI == "OPTIDX" ){
      inputMap.set('Body.product', "FUTOPT");
    }else{
      inputMap.set('Body.product', productFromUI);
    }
    inputMap.set('Body.protectionPercent', 0);
    inputMap.set('Body.priceViolation', 0);
    inputMap.set('Body.quantity', parseInt(this.spnQuantity.getFieldValue()));
    inputMap.set('Body.referenceId', "");
    if(ProductValue == "EQUITY" || ProductValue == "EQUITY MARKET"){
       inputMap.set('Body.segment', "DELIVERY");
    }else if(ProductValue == "FUTCOM" || ProductValue == "OPTCOM" ||ProductValue == "FUTSTK" || ProductValue == "FUTIDX" || ProductValue == "OPTSTK" || ProductValue == "OPTIDX" || ProductValue == "COMDERV" || ProductValue == "FUTOPT"){
      let comdervpriceViolation = null;
      inputMap.set('Body.segment', "CARRYFORWARD");
    } 
    inputMap.set('Body.triprice', parseFloat(this.spnTriggerPrice.getFieldValue()));
    inputMap.set('Body.symbol', this.getSymbol());
    var fieldQuantity = this.spnQuantity.getFieldValue();
    var fieldSymbol = this.getSymbol();
    var fieldexchange = this.cstmExchange.cmbExchange.getFieldValue();
    var fieldproduct = this.cstmProduct.cmbProduct.getFieldValue();
    fieldproduct = this.services.dataStore.getProductForMarketWatch(fieldproduct);
    let key = fieldexchange + "#" + fieldproduct + "#NR#" + fieldSymbol;
      if (this.services.dataStore.stockMasterMap.has(key)) {
          var StockData = this.services.dataStore.stockMasterMap.get(key);
      }
      if(fieldproduct =="COMDERV" || fieldproduct == "FUTOPT"){
        //console.log("StockData.lotsize % fieldQuantity",fieldQuantity % StockData.lotsize);
        if(fieldQuantity % StockData.lotsize != 0){
          document.getElementById('errMsgDiv2').innerHTML = "Quantity should be multiple of lot sizeee";
        } else{
          this.services.http.fetchApi('/orderbook/entry', 'POST', inputMap).subscribe(
            async (httpResponse: HttpResponse<any>) => {
              var res = httpResponse.body;
              var respCode: any = res['respCode'];
              if (respCode != null && respCode == 0) {
                // this.services.alert.showAlert(2, "failed", -1);    
                var successMsg = res['response'];
                successMsg = successMsg.replace(/([\[\]\|\\])+/g, '');
                //document.getElementById('errMsgDiv2').innerHTML = successMsg; //commented by Shanmuga Priya -VAPT
		const plainMsg = successMsg.replace(/<[^>]*>/g, ""); // remove HTML tags
                (document.getElementById('errMsgDiv2') as HTMLElement).textContent = plainMsg;
                this.spnQuantity.setValue("");
                this.cstmPrice.spnPrice.setValue("");
                this.cstmOrderValue.txtOrderValue.setValue("");
                this.spnTriggerPrice.setValue("");
                this.spnMinFillQty.setValue("");
              }
              else {
                // this.services.alert.showAlert(1, "success", 2000);
                //document.getElementById('errMsgDiv2').innerHTML = res['errMsg'];
		//commented by Shanmuga Priya - VAPT
                const rawMsg = res['errMsg'];
                const plainMsg = rawMsg.replace(/<[^>]*>/g, ""); // remove HTML tags
                (document.getElementById('errMsgDiv2') as HTMLElement).textContent = plainMsg;
              }
            },
            async (httpError) => {
              var err = httpError['error']
              if (err != null && err['ErrorElementPath'] != undefined && err['ErrorDescription'] != undefined) {
                if (err['ErrorElementPath'] == 'quantity') {
                  this.spnQuantity.setError(err['ErrorDescription']);
                }
                else if (err['ErrorElementPath'] == 'product') {
                  this.cstmProduct.cmbProduct.setError(err['ErrorDescription']);
                }
                else if (err['ErrorElementPath'] == 'price') {
                  this.cstmPrice.spnPrice.setError(err['ErrorDescription']);
                }
                else if (err['ErrorElementPath'] == 'minFillQty') {
                  this.spnMinFillQty.setError(err['ErrorDescription']);
                }
                else if (err['ErrorElementPath'] == 'filltype') {
                  this.cstmFillType.cmbFillType.setError(err['ErrorDescription']);
                }
                else if (err['ErrorElementPath'] == 'exchange') {
                  this.cstmExchange.cmbExchange.setError(err['ErrorDescription']);
                }
                else if (err['ErrorElementPath'] == 'clientid') {
                  this.cstmInvestorId.cmbInvestorId.setError(err['ErrorDescription']);
                }
                else if (err['ErrorElementPath'] == 'buysell') {
                  this.cmbAction.setError(err['ErrorDescription']);
                }
                else if (err['ErrorElementPath'] == 'boardType') {
                  this.cstmBoard.cmbBoard.setError(err['ErrorDescription']);
                }
              }
              // this.services.alert.showAlert(2, "error part", -1);
              document.getElementById('errMsgDiv').innerHTML = this.transalte('ErrorCodes.SystemDown');
            }
          );
        }
      }
      else{
        this.services.http.fetchApi('/orderbook/entry', 'POST', inputMap).subscribe(
          async (httpResponse: HttpResponse<any>) => {
            var res = httpResponse.body;
            var respCode: any = res['respCode'];
            if (respCode != null && respCode == 0) {
              // this.services.alert.showAlert(2, "failed", -1);    
              var successMsg = res['response'];
              successMsg = successMsg.replace(/([\[\]\|\\])+/g, '');
              //document.getElementById('errMsgDiv2').innerHTML = successMsg; //commented by shanmuga priya
	      const plainMsg = successMsg.replace(/<[^>]*>/g, ""); // remove HTML tags
              (document.getElementById('errMsgDiv2') as HTMLElement).textContent = plainMsg;
              this.spnQuantity.setValue("");
              this.cstmPrice.spnPrice.setValue("");
              this.cstmOrderValue.txtOrderValue.setValue("");
              this.spnTriggerPrice.setValue("");
              this.spnMinFillQty.setValue("");
            }
            else {
              // this.services.alert.showAlert(1, "success", 2000);
              //document.getElementById('errMsgDiv2').innerHTML = res['errMsg'];
	      //commented by Shanmuga Priya - VAPT
                const rawMsg = res['errMsg'];
                const plainMsg = rawMsg.replace(/<[^>]*>/g, ""); // remove HTML tags
                (document.getElementById('errMsgDiv2') as HTMLElement).textContent = plainMsg;
            }
          },
          async (httpError) => {
            var err = httpError['error']
            if (err != null && err['ErrorElementPath'] != undefined && err['ErrorDescription'] != undefined) {
              if (err['ErrorElementPath'] == 'quantity') {
                this.spnQuantity.setError(err['ErrorDescription']);
              }
              else if (err['ErrorElementPath'] == 'product') {
                this.cstmProduct.cmbProduct.setError(err['ErrorDescription']);
              }
              else if (err['ErrorElementPath'] == 'price') {
                this.cstmPrice.spnPrice.setError(err['ErrorDescription']);
              }
              else if (err['ErrorElementPath'] == 'minFillQty') {
                this.spnMinFillQty.setError(err['ErrorDescription']);
              }
              else if (err['ErrorElementPath'] == 'filltype') {
                this.cstmFillType.cmbFillType.setError(err['ErrorDescription']);
              }
              else if (err['ErrorElementPath'] == 'exchange') {
                this.cstmExchange.cmbExchange.setError(err['ErrorDescription']);
              }
              else if (err['ErrorElementPath'] == 'clientid') {
                this.cstmInvestorId.cmbInvestorId.setError(err['ErrorDescription']);
              }
              else if (err['ErrorElementPath'] == 'buysell') {
                this.cmbAction.setError(err['ErrorDescription']);
              }
              else if (err['ErrorElementPath'] == 'boardType') {
                this.cstmBoard.cmbBoard.setError(err['ErrorDescription']);
              }
            }
            // this.services.alert.showAlert(2, "error part", -1);
            document.getElementById('errMsgDiv').innerHTML = this.transalte('ErrorCodes.SystemDown');
          }
        );
      }
    /*actual code
   this.services.http.fetchApi('/orderbook/entry', 'POST', inputMap).subscribe(
      async (httpResponse: HttpResponse<any>) => {
        var res = httpResponse.body;
        var respCode: any = res['respCode'];
        if (respCode != null && respCode == 0) {
          // this.services.alert.showAlert(2, "failed", -1);    
          var successMsg = res['response'];
          successMsg = successMsg.replace(/([\[\]\|\\])+/g, '');
          document.getElementById('errMsgDiv2').innerHTML = successMsg;
          this.spnQuantity.setValue("");
          this.cstmPrice.spnPrice.setValue("");
          this.cstmOrderValue.txtOrderValue.setValue("");
          this.spnTriggerPrice.setValue("");
          this.spnMinFillQty.setValue("");
        }
        else {
          // this.services.alert.showAlert(1, "success", 2000);
          document.getElementById('errMsgDiv2').innerHTML = res['errMsg'];
        }
      },
      async (httpError) => {
        var err = httpError['error']
        if (err != null && err['ErrorElementPath'] != undefined && err['ErrorDescription'] != undefined) {
          if (err['ErrorElementPath'] == 'quantity') {
            this.spnQuantity.setError(err['ErrorDescription']);
          }
          else if (err['ErrorElementPath'] == 'product') {
            this.cstmProduct.cmbProduct.setError(err['ErrorDescription']);
          }
          else if (err['ErrorElementPath'] == 'price') {
            this.cstmPrice.spnPrice.setError(err['ErrorDescription']);
          }
          else if (err['ErrorElementPath'] == 'minFillQty') {
            this.spnMinFillQty.setError(err['ErrorDescription']);
          }
          else if (err['ErrorElementPath'] == 'filltype') {
            this.cstmFillType.cmbFillType.setError(err['ErrorDescription']);
          }
          else if (err['ErrorElementPath'] == 'exchange') {
            this.cstmExchange.cmbExchange.setError(err['ErrorDescription']);
          }
          else if (err['ErrorElementPath'] == 'clientid') {
            this.cstmInvestorId.cmbInvestorId.setError(err['ErrorDescription']);
          }
          else if (err['ErrorElementPath'] == 'buysell') {
            this.cmbAction.setError(err['ErrorDescription']);
          }
          else if (err['ErrorElementPath'] == 'boardType') {
            this.cstmBoard.cmbBoard.setError(err['ErrorDescription']);
          }
        }
        // this.services.alert.showAlert(2, "error part", -1);
        document.getElementById('errMsgDiv').innerHTML = this.transalte('ErrorCodes.SystemDown');
      }
    );*/
  }
  modifyOrder(event) {
    let inputMap = new Map();
    // inputMap.set('Body.boardType', this.cstmBoard.cmbBoard.getFieldValue());
    inputMap.set('Body.buysell', this.params.buySell);
    inputMap.set('Body.clientid', this.cstmInvestorId.cmbInvestorId.getFieldValue());
    inputMap.set('Body.commission', 0);
    inputMap.set('Body.disquan', parseInt(this.cstmRepinQty.spnRepinQty.getFieldValue()));
    inputMap.set('Body.exchange', this.params.exchange);
    inputMap.set('Body.expirydate', this.services.dataStore.dateToDateString(this.cstmValidityDate.dtValidityDate.getFieldValue()));
    inputMap.set('Body.filltype', this.cstmFillType.cmbFillType.getFieldValue());
    inputMap.set('Body.minFillQty', parseInt(this.spnMinFillQty.getFieldValue()));// OB
    inputMap.set('Body.price', parseFloat(this.cstmPrice.spnPrice.getFieldValue()));
    // inputMap.set('Body.priceViolation', 0);
    inputMap.set('Body.pricetype', this.params.orderType);
    inputMap.set('Body.product', this.params.product);
    inputMap.set('Body.protectionPercent', 0);
    inputMap.set('Body.quantity', parseInt(this.spnQuantity.getFieldValue()));
    inputMap.set('Body.referenceId', this.params.referenceId);
    if(this.params.product == "EQUITY" || this.params.product == "EQUITY MARKET"){
      inputMap.set('Body.segment', "DELIVERY");
   }else if(this.params.product == "COMDERV" || this.params.product == "FUTOPT"){
     inputMap.set('Body.segment', "CARRYFORWARD");
   } 
   // inputMap.set('Body.segment', "DELIVERY");
    inputMap.set('Body.triprice', parseFloat(this.spnTriggerPrice.getFieldValue()));
    inputMap.set('Body.symbol', this.params.symbol);
    inputMap.set('Body.pendingqty', this.params.pendingQty); // OB
    inputMap.set('Body.lastModifiedDate', this.params.lastModDate);// OB
    inputMap.set('Body.lastModifiedTime', this.params.lastModTime); // OB
    inputMap.set('Body.reason', "");
    inputMap.set('Body.orderrefno', this.params.orderRefNo); // OB
    inputMap.set('Body.passkey', "");
    //console.log("this.params.product modify",this.params.product);
    //console.log("this.params.symbol modify",this.params.symbol);
    //added by pooja
    var fieldQuantitymodify = this.spnQuantity.getFieldValue();
    var fieldSymbolmodify = this.params.symbol;
    var fieldexchangemodify = this.params.exchange;
    var fieldproductmodify = this.params.product;
    fieldproductmodify = this.services.dataStore.getProductForMarketWatch(fieldproductmodify);
    let key = fieldexchangemodify + "#" + fieldproductmodify + "#NR#" + fieldSymbolmodify;
      if (this.services.dataStore.stockMasterMap.has(key)) {
          var StockDatamodify = this.services.dataStore.stockMasterMap.get(key);
      }
      if(fieldproductmodify =="COMDERV" || fieldproductmodify == "FUTOPT"){
        //console.log("StockDatamodify.lotsize % fieldQuantitymodify",fieldQuantitymodify % StockDatamodify.lotsize);
        if(fieldQuantitymodify % StockDatamodify.lotsize != 0){
          document.getElementById('errMsgDiv2').innerHTML = "Quantity should be multiple of lot sizeee modify";
        }
        else if(this.symbol.endsWith("SPD") || this.symbol.endsWith("spd")){
          document.getElementById('errMsgDiv2').innerHTML = "Spread Order Modification Not Allowed";
        }
        else{
          this.services.http.fetchApi('/orderbook/modify', 'POST', inputMap).subscribe(
            async (httpResponse: HttpResponse<any>) => {
              var res = httpResponse.body;
              var respCode: any = res['respCode'];
              if (respCode != null && respCode == 0) {
                // this.services.alert.showAlert(2, "failed", -1);    
                var successMsg = res['response']["displaytext"];
                successMsg = successMsg.replace(/([\[\]\|\\])+/g, '');
                //document.getElementById('errMsgDiv2').innerHTML = successMsg; //commented by Shanmuga Priya
		const plainMsg = successMsg.replace(/<[^>]*>/g, ""); // remove HTML tags
              (document.getElementById('errMsgDiv2') as HTMLElement).textContent = plainMsg;
              }
              else {
                // this.services.alert.showAlert(1, "success", 2000);
                //document.getElementById('errMsgDiv2').innerHTML = res['errMsg'];
		//commented by Shanmuga Priya - VAPT
                const rawMsg = res['errMsg'];
                const plainMsg = rawMsg.replace(/<[^>]*>/g, ""); // remove HTML tags
                (document.getElementById('errMsgDiv2') as HTMLElement).textContent = plainMsg;
              }
            },
            async (httpError) => {
              var err = httpError['error']
              if (err != null && err['ErrorElementPath'] != undefined && err['ErrorDescription'] != undefined) {
                if (err['ErrorElementPath'] == 'quantity') {
                  this.spnQuantity.setError(err['ErrorDescription']);
                }
                else if (err['ErrorElementPath'] == 'product') {
                  this.cstmProduct.cmbProduct.setError(err['ErrorDescription']);
                }
                else if (err['ErrorElementPath'] == 'price') {
                  this.cstmPrice.spnPrice.setError(err['ErrorDescription']);
                }
                else if (err['ErrorElementPath'] == 'minFillQty') {
                  this.spnMinFillQty.setError(err['ErrorDescription']);
                }
                else if (err['ErrorElementPath'] == 'filltype') {
                  this.cstmFillType.cmbFillType.setError(err['ErrorDescription']);
                }
                else if (err['ErrorElementPath'] == 'exchange') {
                  this.cstmExchange.cmbExchange.setError(err['ErrorDescription']);
                }
                else if (err['ErrorElementPath'] == 'clientid') {
                  this.cstmInvestorId.cmbInvestorId.setError(err['ErrorDescription']);
                }
                else if (err['ErrorElementPath'] == 'buysell') {
                  this.cmbAction.setError(err['ErrorDescription']);
                }
                else if (err['ErrorElementPath'] == 'boardType') {
                  this.cstmBoard.cmbBoard.setError(err['ErrorDescription']);
                }
              }
            }
          );
        }
      }else{
        this.services.http.fetchApi('/orderbook/modify', 'POST', inputMap).subscribe(
          async (httpResponse: HttpResponse<any>) => {
            var res = httpResponse.body;
            var respCode: any = res['respCode'];
            if (respCode != null && respCode == 0) {
              // this.services.alert.showAlert(2, "failed", -1);    
              var successMsg = res['response']["displaytext"];
              successMsg = successMsg.replace(/([\[\]\|\\])+/g, '');
              //document.getElementById('errMsgDiv2').innerHTML = successMsg; //commented by Shanmuga Priya
	      const plainMsg = successMsg.replace(/<[^>]*>/g, ""); // remove HTML tags
              (document.getElementById('errMsgDiv2') as HTMLElement).textContent = plainMsg;
            }
            else {
              // this.services.alert.showAlert(1, "success", 2000);
              //document.getElementById('errMsgDiv2').innerHTML = res['errMsg'];
	      //commented by Shanmuga Priya - VAPT
                const rawMsg = res['errMsg'];
                const plainMsg = rawMsg.replace(/<[^>]*>/g, ""); // remove HTML tags
                (document.getElementById('errMsgDiv2') as HTMLElement).textContent = plainMsg;
            }
          },
          async (httpError) => {
            var err = httpError['error']
            if (err != null && err['ErrorElementPath'] != undefined && err['ErrorDescription'] != undefined) {
              if (err['ErrorElementPath'] == 'quantity') {
                this.spnQuantity.setError(err['ErrorDescription']);
              }
              else if (err['ErrorElementPath'] == 'product') {
                this.cstmProduct.cmbProduct.setError(err['ErrorDescription']);
              }
              else if (err['ErrorElementPath'] == 'price') {
                this.cstmPrice.spnPrice.setError(err['ErrorDescription']);
              }
              else if (err['ErrorElementPath'] == 'minFillQty') {
                this.spnMinFillQty.setError(err['ErrorDescription']);
              }
              else if (err['ErrorElementPath'] == 'filltype') {
                this.cstmFillType.cmbFillType.setError(err['ErrorDescription']);
              }
              else if (err['ErrorElementPath'] == 'exchange') {
                this.cstmExchange.cmbExchange.setError(err['ErrorDescription']);
              }
              else if (err['ErrorElementPath'] == 'clientid') {
                this.cstmInvestorId.cmbInvestorId.setError(err['ErrorDescription']);
              }
              else if (err['ErrorElementPath'] == 'buysell') {
                this.cmbAction.setError(err['ErrorDescription']);
              }
              else if (err['ErrorElementPath'] == 'boardType') {
                this.cstmBoard.cmbBoard.setError(err['ErrorDescription']);
              }
            }
          }
        );

      }
        //addded by pooja ends

    /*this.services.http.fetchApi('/orderbook/modify', 'POST', inputMap).subscribe(
      async (httpResponse: HttpResponse<any>) => {
        var res = httpResponse.body;
        var respCode: any = res['respCode'];
        if (respCode != null && respCode == 0) {
          // this.services.alert.showAlert(2, "failed", -1);    
          var successMsg = res['response']["displaytext"];
          successMsg = successMsg.replace(/([\[\]\|\\])+/g, '');
          document.getElementById('errMsgDiv2').innerHTML = successMsg;
        }
        else {
          // this.services.alert.showAlert(1, "success", 2000);
          document.getElementById('errMsgDiv2').innerHTML = res['errMsg'];
        }
      },
      async (httpError) => {
        var err = httpError['error']
        if (err != null && err['ErrorElementPath'] != undefined && err['ErrorDescription'] != undefined) {
          if (err['ErrorElementPath'] == 'quantity') {
            this.spnQuantity.setError(err['ErrorDescription']);
          }
          else if (err['ErrorElementPath'] == 'product') {
            this.cstmProduct.cmbProduct.setError(err['ErrorDescription']);
          }
          else if (err['ErrorElementPath'] == 'price') {
            this.cstmPrice.spnPrice.setError(err['ErrorDescription']);
          }
          else if (err['ErrorElementPath'] == 'minFillQty') {
            this.spnMinFillQty.setError(err['ErrorDescription']);
          }
          else if (err['ErrorElementPath'] == 'filltype') {
            this.cstmFillType.cmbFillType.setError(err['ErrorDescription']);
          }
          else if (err['ErrorElementPath'] == 'exchange') {
            this.cstmExchange.cmbExchange.setError(err['ErrorDescription']);
          }
          else if (err['ErrorElementPath'] == 'clientid') {
            this.cstmInvestorId.cmbInvestorId.setError(err['ErrorDescription']);
          }
          else if (err['ErrorElementPath'] == 'buysell') {
            this.cmbAction.setError(err['ErrorDescription']);
          }
          else if (err['ErrorElementPath'] == 'boardType') {
            this.cstmBoard.cmbBoard.setError(err['ErrorDescription']);
          }
        }
      }
    );*/
  }
  cancelOrder(event) {
    let inputMap = new Map();
    inputMap.set('Body.clientid', this.cstmInvestorId.cmbInvestorId.getFieldValue());
    inputMap.set('Body.product', this.params.product);
    inputMap.set('Body.symbol', this.params.symbol);
    inputMap.set('Body.lastModifiedDate', this.params.lastModDate);// OB
    inputMap.set('Body.lastModifiedTime', this.params.lastModTime); // OB
    inputMap.set('Body.orderno', this.params.orderRefNo);// OB
    this.services.http.fetchApi('/orderbook/cancel', 'POST', inputMap).subscribe(
      async (httpResponse: HttpResponse<any>) => {
        var res = httpResponse.body;
        var respCode: any = res['respCode'];
        if (respCode != null && respCode == 0) {
          // this.services.alert.showAlert(2, "failed", -1);    
          var successMsg = res['response'];
          successMsg = successMsg.replace(/([\[\]\|\\])+/g, '');
          //document.getElementById('errMsgDiv2').innerHTML = successMsg;//commented by Shanmuga Priya
	  const plainMsg = successMsg.replace(/<[^>]*>/g, ""); // remove HTML tags
          (document.getElementById('errMsgDiv2') as HTMLElement).textContent = plainMsg;
        }
        else {
          // this.services.alert.showAlert(1, "success", 2000);
          //document.getElementById('errMsgDiv2').innerHTML = res['errMsg'];
	  //commented by Shanmuga Priya - VAPT
          const rawMsg = res['errMsg'];
          const plainMsg = rawMsg.replace(/<[^>]*>/g, ""); // remove HTML tags
          (document.getElementById('errMsgDiv2') as HTMLElement).textContent = plainMsg;
        }
      },
      async (httpError) => {
        var err = httpError['error']
        if (err != null && err['ErrorElementPath'] != undefined && err['ErrorDescription'] != undefined) {
          if (err['ErrorElementPath'] == 'product') {
            this.cstmProduct.cmbProduct.setError(err['ErrorDescription']);
          }
          else if (err['ErrorElementPath'] == 'clientid') {
            this.cstmInvestorId.cmbInvestorId.setError(err['ErrorDescription']);
          }
        }
        document.getElementById('errMsgDiv2').innerHTML = this.transalte('ErrorCodes.SystemDown');
      }
    );
  }
  quantiyValidation(event) {
    if (event.keyCode === 69 || event.keyCode === 38 || event.keyCode === 40 ||
      event.keyCode === 187 || event.keyCode === 189 || event.keyCode === 190) {
      return false;
    }
  }
  priceValidation(event) {
    if (event.keyCode === 69 || event.keyCode === 38 || event.keyCode === 40 ||
      event.keyCode === 187 || event.keyCode === 189) {
      return false;
    }
  }

  transalte(text) {
    return this.services.translate.instant(text);
  }
  fieldDependencies = {
  }
  /* Write Custom Scripts Here */
  buyingSummary: any = "";
  availableQty: any = "";
  exchange: string = '';
  product: string = '';
  exchSymbol: string = '';
  symbol: string = '';
  subbedStock = null;
  keyValueList: any[] = [];
  //selectedStock: any;
  derProduct = false;
  reloadStock(board) {
    if (this.cstmExchange != undefined) {
      let exch = this.cstmExchange.cmbExchange.getFieldValue();
      let pdct = this.cstmProduct.cmbProduct.getFieldValue();
      let pdctSel = this.cstmProduct.cmbProduct.getFieldValue();
      if (typeof pdct == 'object' ){
        pdct = pdct.text
    }
      if(pdct == "EQUITY" || pdct == "EQUITY MARKET" || pdct == "DEBT" ||  pdct == "FUTSTK" || pdct == "FUTIDX" || pdct == "OPTSTK" || pdct == "OPTIDX"){
        this.derProduct = false;
      }else{
        this.derProduct = true;
      }

      if(pdct =="EQUITY" || pdct =="EQUITY MARKET"){
        this.productData = true;
      }else{
      this.productData = false;
      }


      pdct = this.services.dataStore.getDerivativeTypeConverter(pdct);
      /*if(pdct == "EQUITY" || pdct == "DEBT"){
       // board = "AL"; //commented by pooja to check for spot watch
        //this.derProduct = false;
   }else{
       // board = "NR"; //commented by pooja to check for spot watch
        //this.derProduct = true;
   }*/
   //pdct = this.services.dataStore.getDerivativeTypeConverter(pdct);
      this.cmbStock.gotxInput.val("");
      this.cmbStock.source = this.services.dataStore.getcmbStockInput(this.cmbStock.searchMode, exch, pdct, board);
      this.cstmProduct.cmbProduct.dropDownOptions.Options = this.services.dataStore.getcmbProductderivative();
      if (typeof pdctSel == 'object' ){
        pdctSel = pdctSel.text
    }
      this.cstmProduct.cmbProduct.setValue(pdctSel);
    }
  }

}
